// lib/kampfTechniken.js — Abschrift von backend/utils/kampfTechniken.js (Test vergleicht beide).
// Wertungsknöpfe der Kampfrichter-App je Sportart (21.10.2026) und die
// Technik, die mit einem Punkt mitgeschickt wird.
//
// Pointfighting: +1 Fauststoß, +2 Fußtritt zum Körper, +3 Fußtritt zum Kopf.
// Grundlage: die Punktetafel-Abnahme des Veranstalters (20.10.2026, „1
// Fauststoß, 2 Fußtritt zum Körper, 3 Fußtritt zum Kopf“) und die
// gespeicherte Schreiber-Einstellung modus_display_config pointfighting/
// schreiber pointButtons [1,2,3]. Der Erklärtext der Modus-Übersicht ist
// seit 21.10.2026 angeglichen (Entscheidung des Veranstalters).
//
// Die Kampfrichter-App schickt { points, technik } im Ereignis „score“; der
// Server übernimmt die Technik nur, wenn sie hier zu Sportart und Punktzahl
// passt (technikPruefen), und reicht sie als letzte_wertung an die Anzeigen
// weiter. Die Punktetafel zeigt sie in der Laufzeile „Letzte Wertung“ statt
// sie aus der Punktzahl zu raten.
//
// Abschrift für das Frontend: frontend/src/lib/kampfTechniken.js,
// verglichen in utils/__tests__/kampfTechniken.test.js.
const { sportartVon } = require('./minuspunkte');

const KNOEPFE = {
  pointfighting: [
    { punkte: 1, technik: 'Fauststoß' },
    { punkte: 2, technik: 'Fußtritt zum Körper' },
    { punkte: 3, technik: 'Fußtritt zum Kopf' },
  ],
  // Übrige Kickbox-Sportarten (Continuous, K1, Fullcontact, Kickboxen):
  // Bedienung wie bisher
  kickboxen: [
    { punkte: 1, technik: 'Technik' },
    { punkte: 2, technik: 'Kombination / Sprung' },
  ],
  // Kumite-Bedienung (auch Grappling, Rumble in der App)
  kumite: [
    { punkte: 1, technik: 'Yuko' },
    { punkte: 2, technik: 'Waza-ari' },
    { punkte: 3, technik: 'Ippon' },
  ],
};

/** Knöpfe für eine Matte: Pointfighting eigen, sonst nach Bedienung. */
function knoepfeFuer({ sessionTyp, divisionType, modusId } = {}) {
  const sportart = sportartVon({ sessionTyp, divisionType, modusId });
  if (sportart === 'pointfighting') return KNOEPFE.pointfighting;
  return String(sessionTyp || '').toLowerCase() === 'kickboxen' ? KNOEPFE.kickboxen : KNOEPFE.kumite;
}

/** Technik übernehmen, wenn sie zu Sportart und Punktzahl passt, sonst null. */
function technikPruefen(angaben, punkte, technik) {
  if (typeof technik !== 'string') return null;
  const t = technik.trim();
  const k = knoepfeFuer(angaben).find((x) => x.punkte === Number(punkte) && x.technik === t);
  return k ? k.technik : null;
}

module.exports = { KNOEPFE, knoepfeFuer, technikPruefen };
